
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import { notifiedStatusList, timeTypeList } from '@/utils/constant'
import { transactionInfo } from '@/api/antManage/antManage'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import { getConstant } from '@/api/universal'
// const initDate = getCurrentDate()
@Component({
  name: 'transaction',
  components: {}
})
export default class extends Vue {
  @Prop() merchant!: any
  @Prop({ required: true }) private merchantId!: any
  get language () {
    return AppModule.language
  }
  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }
  queryForm: any = {
    order_number: this.merchant.event.order,
    min_amount: null,
    max_amount: null,
    start_time: null,
    end_time: null,
    cause: null
  }
  // 重置
  private reset() {
    this.date = getCurrentDate()
    this.queryForm = {
      order_number: null,
      min_amount: null,
      max_amount: null,
      start_time: dateToSeconds(this.date[0]),
      end_time: dateToSeconds(this.date[1]),
      cause: null
    }
    this.onloadTransactionInfo()
  }
  private total = 0
  private onloadLoading = false
  // private date: any[] = []
  private date: any[] = getCurrentDate()
  private timeTypeList = timeTypeList
  private pickerOptions = pickerOptions
  private loading: boolean = false

  private back () {
    this.$emit('close', false)
  }
  private select () {
    this.onloadTransactionInfo()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.onloadTransactionInfo()
  }

  // 分页切换22
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.onloadTransactionInfo()
  }
  private fileList: any[] = []
  private async onloadTransactionInfo () {
    try {
      this.loading = true
      let params:any = {
        name: this.merchantId,
        body: {
          ...this.queryForm,
          page_size: this.pagesize,
          page: this.currentPage
        }
      }
      console.log(this.queryForm, this.merchant)

      await transactionInfo(params).then((res: any) => {
        this.total = res.count
        this.fileList = res.results
        console.log(this.fileList.length)

        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private constantList: any = []
  // 获取常量
  private async onloadConstant () {
    try {
      await getConstant().then((res: any) => {
        this.constantList = res.ANT_FUND_CAUSE_CHOICES
      })
    } catch (e) {
    }
  }

  mounted () {
    this.onloadConstant()
    this.onloadTransactionInfo()
  }
}
